import type { TrackFunction } from "@similarweb/contact-us";

import createTrackingEventName from "app/pages/sales-intelligence/utils/testing/createTrackingEventName";

enum FindAppsTrackingAction {
    Hover = "hover",
    Click = "click",
    Expand = "expand",
    Collapse = "collapse",
    SelectValue = "select value",
}

export default function createFindAppsTrackingService(track: TrackFunction) {
    function trackFindAppsEvent(
        category: string,
        action: FindAppsTrackingAction,
        eventName: string,
        eventSubName: string,
        eventSubSubName?: string,
    ): void {
        const event: string = createTrackingEventName(eventName, eventSubName, eventSubSubName);

        track(category, action, event);
    }

    function trackTable(action: FindAppsTrackingAction, eventName: string, eventSubName: string): void {
        trackFindAppsEvent("table", action, eventName, eventSubName);
    }

    function trackFilterPanel(
        action: FindAppsTrackingAction,
        eventName: string,
        eventSubName: string,
        eventSubSubName: string,
    ): void {
        trackFindAppsEvent("filters panel", action, eventName, eventSubName, eventSubSubName);
    }

    return {
        trackTabChange(tabName: string) {
            trackTable(FindAppsTrackingAction.Click, "switch tab", tabName);
        },
        trackExpandCollapseFilter(isExpand: boolean, tabName: string, filterName: string) {
            trackFilterPanel(
                isExpand ? FindAppsTrackingAction.Expand : FindAppsTrackingAction.Collapse,
                isExpand ? "expand filter" : "collapse filter",
                filterName,
                tabName,
            );
        },
        trackFilterValue(tabName: string, filterName: string, filterValue: string) {
            trackFilterPanel(FindAppsTrackingAction.SelectValue, filterName, tabName, filterValue);
        },
    };
}
